import {
  GET_NEWSLETTER,
  GET_NEWSLETTER_SUCCESS,
  GET_NEWSLETTER_ERROR,
  GET_NEWSLETTERS,
  GET_NEWSLETTERS_SUCCESS,
  GET_NEWSLETTERS_ERROR } from "../../constants/actionTypes";
import initialState from "../../config/initialState";


export default (state = initialState, action) => {
  switch (action.type) {
    case GET_NEWSLETTER:
    case GET_NEWSLETTERS: {
      return {
        ...state,
        isLoading: true,
        isFinished: false,
        isError: false,
        error: null,
      };
    }

    case GET_NEWSLETTER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        data: action.payload,
      };
    }

    case GET_NEWSLETTERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        results: action.payload,
      };
    }

    case GET_NEWSLETTER_ERROR:
    case GET_NEWSLETTERS_ERROR: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        isError: true,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/subscriptions/reducers/newsletters.js